import React, { Component } from 'react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../../Common/constants';
import Spinner from '../../../components/Widgets/spinner';
import { DatePicker } from '../../Common/datePicker';
import { DateFormatter } from '../../Common/dateFormat';
import CashFormatter from '../../Common/cashFormatter';
import PriceFormatter from '../../Common/priceFormatter';
import { numberWithCommas } from '../../Common/numberWithCommas';
import { DisabledInputField } from '../../Common/inputField';
import { toFromDates, dateFormat, minDate, maxDate } from '../../Common/cleanDates';
import dateFilterRadios from '../../Common/dateFilterRadios';
import {
  ROOT_URL, companyCodeTitle, isOCM, isLAP, isGGI, isSUN, isCPG, isOLG, isVIP, isHO
} from '../../../actions/root_url';
import PaymentAmountFormatter from './PaymentAmountFormatter';
import genericRadioFilter from '../../Common/genericRadioFilter';
import { isDst } from '../../Common/NumberUtil';


momentLocalizer(moment);

class SIPaymentList extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage,
      createOpen: false,
      tableData: {
        rows: [],
        selectedRows: null,
        filters: {},
        searchFilters: {},
        sortColumn: null,
        sortDirection: null,
      },
      // rows: [],
      // selectedRows: null,
      // editedRows: [],
      // filters: {},
      // sortColumn: null,
      // sortDirection: null,
      gourpOpen: false,
      profit: 0,
      margin: 0,
      total: 0,
      paid: 0,
      balance: 0,
      Days: '7',
      FromDate: undefined,
      ToDate: undefined,
      rowsCount: 0,
      orderType: null,
    };

    this.handleResize = this.handleResize.bind(this);
    this.invoiceDetail = this.invoiceDetail.bind(this);
  }

  componentWillMount() {
    document.title = companyCodeTitle;
    this.props.setDefaultDays('SIPaymentList');
    // last param set to true, indecating it's sales report
    this.props.fetchSalesInvoices('all/', '1900-01-01', '3000-01-01', null, '7', null, null, null, true);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.props.setDefaultDays('SIPaymentList');
    this.props.fetchSalesInvoices('all/', '1900-01-01', '3000-01-01', null, '7', null, null, null, true);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.salesInvoice && nextProps.salesInvoice !== this.props.salesInvoice) {
      const invoices = nextProps.salesInvoice.Invoices;
      const total = nextProps.salesInvoice.TotalFinalPrice;
      const paid = nextProps.salesInvoice.TotalPaid;
      const balance = isHO ? nextProps.salesInvoice.TotalSIFinalPrice : nextProps.salesInvoice.TotalBalance;
      const profit = nextProps.salesInvoice.TotalProfit;
      const margin = nextProps.salesInvoice.TotalMargin;
      const tableData = { ...this.state.tableData, rows: invoices };
      this.setState({
        tableData,
        total,
        paid,
        balance,
        profit,
        margin,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tableData !== this.state.tableData) {
      this.setState({ rowsCount: Data.Selectors.getRows(this.state.tableData).length });
    }
    if (prevProps.selectedWarehouse !== this.props.selectedWarehouse && this.props.selectedWarehouse.value !== undefined) {
      this.refreshList();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage });
  }

  invoiceDetail = (e) => {
    e.preventDefault();
    const selectedRow = this.state.tableData.selectedRows[0];
    this.context.router.push(`/salesInvoicePayment/${selectedRow.SalesInvoice_id}`);
  }

  formatDate = date => moment(date).format('YYYY-MM-DD');

  fetchSalesInvoiceByDetails = (days) => {
    if (days != '-1') {
      this.setState(
        { FromDate: undefined, ToDate: undefined, Days: days },
        () => { this.props.fetchSalesInvoices('all/', this.state.FromDate, this.state.ToDate, null, this.state.Days, null, null, null, true, this.state.orderType); },
      );
    } else {
      this.setState(
        { Days: '-1' },
        () => { this.props.fetchSalesInvoices('all/', this.state.FromDate, this.state.ToDate, null, this.state.Days, null, null, null, true, this.state.orderType); },
      );
    }
  }

  refreshList = (searchFilters) => {
    this.props.fetchSalesInvoices('all/', this.state.FromDate, this.state.ToDate, null, this.state.Days, null, null, null, true, this.state.orderType, searchFilters)
  }

  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({ ToDate: e });
  }

  setFromDate = (e) => {
    if (e > this.state.ToDate) {
      return;
    }
    this.setState({ FromDate: e });
  }

  setToRangeSearch = (e) => {
    this.setState({ Days: '-1' });
  }

  renderTable() {
    if (this.props.isLoading && !this.props.error) {
      return <Spinner />;
    } else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            {JSON.stringify(this.props.error)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const tableHeight = (window.innerHeight < 930) ? 460 : 460;

    const getRows = () => Data.Selectors.getRows(this.state.tableData);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the row select function
    const onRowSelect = (rows) => {
      const tableData = { ...this.state.tableData, selectedRows: rows };
      this.setState({ tableData });
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.tableData, { sortColumn: sortColumn, sortDirection: sortDirection });
      this.setState({ tableData: state });
    };

    const handleFilterChange = (filter) => {
      if (isHO) {
        const searchFilters = Object.assign({}, this.state.searchFilters);
        if (filter.filterTerm) {
          searchFilters[filter.column.key] = filter.filterTerm;
        } else {
          delete searchFilters[filter.column.key];
        }
        this.setState({
          searchFilters
        })
        const paramsData = ['InvoiceNum', 'SONum', 'CustomerNum', 'Customer_Name', 'Sales_Username', 'PaymentType', 'PaymentStatusRecord'];
        if (paramsData.includes(filter.column.key)) {
          this.refreshList(searchFilters)
        }   
        return;
      }
      const newFilters = Object.assign({}, this.state.tableData.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const tableData = { ...this.state.tableData, filters: newFilters };
      this.setState({ tableData });
    };

    // Column difinition
    const columns = [
      {
        key: 'InvoiceNum',
        name: <Translate value="si_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'SONum',
        name: <Translate value="related_no" />,
        resizable: true,
        sortable: true,
        width: 110,
        filterable: true,
      },
      {
        key: 'PostingDate',
        name: <Translate value="posting_date" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'CustomerNum',
        name: <Translate value="customer_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      ...isGGI ? [
        {
          key: 'CustomerID',
          name: <Translate value="customer_id" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
      ]:[],
      {
        key: 'Customer_Name',
        name: <Translate value="customer_name" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
      },
      {
        key: 'FinalPrice',
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'PaymentAmount',
        name: <Translate value="paid_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
        formatter: CashFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'UnpaidAmount',
        name: <Translate value="balance" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'Sales_Username',
        name: <Translate value="sales" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: 'Owner',
        name: <Translate value="owner" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
      },
      {
        key: isOLG? 'NEWPaymentType':'PaymentType',
        name: <Translate value="payment" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'SaleStatus',
        name: <Translate value="si_status" />,
        resizable: true,
        sortable: true,
        width: 85,
        filterable: true,
      },
      {
        key: 'PaymentStatusRecord',
        name: <Translate value="pmt_status" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      ...(isLAP || isCPG || isSUN || isVIP || isHO) ? [{
        key: "Profit",
        name: <Translate value="profit" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
      ...(isLAP || isCPG || isSUN || isVIP || isHO) ? [{
        key: "SalesMargin",
        name: <Translate value="sales_margin" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
      {
        key: 'CheckNum',
        name: <Translate value="check_num" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'Note',
        name: <Translate value="note" />,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <div>
        <Row>
          <Col xs={12}>
            <div id="SIPaymentList">
              <ReactDataGrid
                rowKey="InvoiceNum"
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowGetter={rowGetter}
                headerRowHeight={45}
                rowsCount={getSize()}
                rowHeight={25}
                minHeight={tableHeight}
                enableRowSelect="single"
                onRowSelect={onRowSelect}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div>
              <Col xs={2}>
                <label style={{ 'display': 'inline-flex', 'margin-top': '15px' }}>
                  <Translate value="rows" />:&nbsp;
                  <span className="font-color-orange">{ this.state.rowsCount }</span>
                </label>
              </Col>
              <Col xs={3}>
                <label style={{ display: 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                  <span style={{ 'margin-top': '3px' }}>
                    <Translate value={isHO ? "si_final" : "subtotal"} /><span className="dollar-sign"> $$</span>:&nbsp;
                  </span>
                  <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.balance)}` || 0} />
                </label>
              </Col>
              <Col xs={3}>
                <label style={{ display: 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                  <span style={{ 'margin-top': '3px' }}>
                    <Translate value={isHO ? "return_final" : "fees_discount"} /><span className="dollar-sign"> $$</span>:&nbsp;
                  </span>
                  <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.paid)}` || 0} />
                </label>
              </Col>
              <Col xs={3}>
                <label style={{ display: 'inline-flex', 'margin-top': '15px', 'margin-left': '10px' }}>
                  <span style={{ 'margin-top': '3px' }}>
                    <Translate value="net_sales" /><span className="dollar-sign"> $$</span>:&nbsp;
                  </span>
                  <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.total)}` || 0} />
                </label>
              </Col>
            </div>
          </Col>
        </Row>

{(isLAP || isCPG || isSUN || isVIP || isHO) &&
 <Row>
 <Col xs={12}>
   <div>
     <Col xs={2}>
       
     </Col>
     <Col xs={3}>
       <label style={{ display: 'inline-flex', 'margin-top': '8px', 'margin-left': '10px' }}>
         <span style={{ 'margin-top': '3px' }}>
           <Translate value="profit" /><span className="dollar-sign"> $$</span>:&nbsp;
         </span>
         <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.profit)}` || 0} />
       </label>
     </Col>
     <Col xs={3}>
       <label style={{ display: 'inline-flex', 'margin-top': '8px', 'margin-left': '10px' }}>
         <span style={{ 'margin-top': '3px' }}>
           <Translate value="margin" /><span className="dollar-sign"></span>:&nbsp;
         </span>
         <Field component={DisabledInputField} placeholder={`${numberWithCommas(this.state.margin)}` || 0} />
       </label>
     </Col>
   </div>
 </Col>
</Row>
}

      </div>
    );
  }

  renderDatePickers() {
    if (this.props.Days === '-1') {
      return (
        <div className="form-group date-picker-positioner">
          <label className="col-xs-2 from-label col-xs-offset-5">
            <Translate value="from" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="FromDate" component={DatePicker} disabled={this.props.Days !== '-1'} />
          </div>
          <label className="col-xs-1 to-label">
            <Translate value="to" />
          </label>
          <div className="col-xs-2 control-date-picker">
            <Field name="ToDate" component={DatePicker} disabled={this.props.Days !== '-1'} />
          </div>
        </div>
      );
    }
    // else return(
    //   <Row>
    //     <Col xs={ 10 }></Col>
    //     <Col xs={ 2 }>
    //       <Button
    //         bsStyle='primary'
    //         onClick={() =>{ this.fetchSalesInvoiceByDetails(); }}><Translate value"submit" />
    //       </Button>
    //     </Col>
    //   </Row>
    // )
  }

  renderPrint() {
    const salesInvoiceID = this.state.tableData.selectedRows && this.state.tableData.selectedRows.length === 1 && this.state.tableData.selectedRows[0].SalesInvoice_id;
    if (!salesInvoiceID) {
      return;
    }
    let url = `${ROOT_URL}v1/sale/printinvoice/${salesInvoiceID}?Bearer=${localStorage.getItem('token')}`;
    if(isOLG) {
      let sq = new Date().getTimezoneOffset();
      let time = -sq / 60;
      if(sq > 0 && isDst()) {
        sq+=60;
        let zone = -sq / 60;
        url += `&time_zone=${zone}&time_diff=${time}`;
      } else {
        url += `&time_zone=${(time)}&time_diff=${time}`;
      }
    }
    return (
      <Button
        bsStyle="primary"
        type="button"
        href={url}
      >
        <em className="fa fa-print" /><Translate value="print_si" />
      </Button>
    );
  }

  renderReturnPrint() {
    const salesReturnID = this.state.tableData.selectedRows && this.state.tableData.selectedRows.length === 1 && this.state.tableData.selectedRows[0].SalesReturn_id;
    if (!salesReturnID) {
      return;
    }
    const url = `${ROOT_URL}v1/sale/printreturn/${salesReturnID}?Bearer=${localStorage.getItem('token')}`;

    return (
      <Button
        bsStyle="primary"
        type="button"
        href={url}
      >
        <em className="fa fa-print" /><Translate value="print_return" />
      </Button>
    );
  }

  renderButtonToolbar() {
    let { FromDate: fromDate, ToDate: toDate, searchFilters } = this.state;
    const { Days: days } = this.state;
    const dates = toFromDates(days, fromDate, toDate);
    fromDate = `PostingDate__gte=${dates.fromDate}`;
    toDate = `PostingDate__lte=${dates.toDate}`;
    const token = `Bearer=${localStorage.getItem('token')}`;
    const Company_id = this.props.selectedCompany &&  this.props.selectedCompany.value;
    const paramsData = {
      'InvoiceNum': 'invoiceNum',
      'SONum': 'soNum',
      'CustomerNum': 'customerNum',
      'Customer_Name': 'customerName',
      'Sales_Username': 'salesUsername',
      'PaymentType': 'paymentType',
      'PaymentStatusRecord': 'paymentStatusRecord'
    }
    let filtersData = ''
    if (isHO) {
      if (searchFilters) {
        for (var key in searchFilters) {
          if (paramsData[key]) {
            filtersData += `&${paramsData[key]}=${searchFilters[key]}`
          }
        }
      }
    }
    const url = `${ROOT_URL}v1/sale/sales_invoice/search/all/exportpayment/?${fromDate}&${toDate}&${token}&Company_id=${Company_id}${filtersData}`;
    const byUserUrl = `${ROOT_URL}v1/sale/sales_invoice/search/all/export_by_user/?${fromDate}&${toDate}&${token}&Company_id=${Company_id}${filtersData}`;
    return (
      <ButtonToolbar>
        <Button
          bsStyle="success"
          type="button"
          href={byUserUrl}
        >
          <em className="fa fa-download" /><Translate value="excel_by_user" />
        </Button>
        <Button
          bsStyle="success"
          type="button"
          href={url}
        >
          <em className="fa fa-download" /><Translate value="excel" />
        </Button>
      </ButtonToolbar>
    );
  }

  handleOrderTypeChange = (orderType) => {
    this.setState({
      orderType,
    }, () => {
      this.refreshList();
    })
  }

  renderOrderTypeRadios = () => {
    if (!isOCM) return null;

    return (
      <Row>
        <Col xs={1}>
          <h3 className="filter-title text-nowrap"><Translate value="order_type" /><span className="colon">:</span></h3>
        </Col>
        <Col xs={11}>
        <div id="statusFilterRadios">
          {
            genericRadioFilter({
              content: [
                {
                  option: null,
                  id: 'ordertypeall-status-radio-filter',
                  name: 'ordertypeFilterRadios',
                  labelName: 'normal',
                },
                {
                  option: 'IsRelocation',
                  id: 'relocate-radio-filter',
                  name: 'ordertypeFilterRadios',
                  labelName: 'relocate',
                },
                {
                  option: 'IsTransfer',
                  id: 'transfer-radio-filter',
                  name: 'ordertypeFilterRadios',
                  labelName: 'transfer',
                },
              ],
              value: this.state.orderType,
              handleOnClick: this.handleOrderTypeChange,
              type: 'buttons',
            })
          }
        </div>
        </Col>
      </Row>
    )
  }

  render() {
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="sales_report" />
          </Breadcrumb.Item>
        </Breadcrumb>

        { this.renderButtonToolbar() }

        <Grid id="purchase-payment">
          {/* <h1><Translate value="si_payment" /></h1> */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={1}>
                    <h3 className="filter-title text-nowrap"><Translate value="posting_date" /><span className="colon">:</span></h3>
                  </Col>
                  <Col xs={11}>
                    {
                      dateFilterRadios({
                        handleOnClick: this.fetchSalesInvoiceByDetails,
                        setFromDate: this.setFromDate,
                        setToDate: this.setToDate,
                        setToRangeSearch: this.setToRangeSearch,
                        FromDate: this.state.FromDate,
                        ToDate: this.state.ToDate,
                        Days: this.state.Days,
                      })
                    }
                  </Col>
                </Row>
                {this.renderOrderTypeRadios()}
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Panel className="position-relative table-collapse-fix">
                <ButtonToolbar className="table-buttons">
                  <Button
                    bsStyle="primary"
                    disabled={!this.state.tableData.selectedRows || this.state.tableData.selectedRows.length !== 1}
                    onClick={this.invoiceDetail}
                  >
                    <em className="fa fa-file-text" />
                    <Translate value="detail" />
                  </Button>
                  { this.renderPrint() }
                  { this.renderReturnPrint() }
                </ButtonToolbar>
                { this.renderTable() }
              </Panel>
            </Col>
          </Row>
        </Grid>
      </ContentWrapper>
    );
  }
}

export default SIPaymentList;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/SIPaymentList/SIPaymentList.jsx